import React from 'react';
import { useSelector } from 'react-redux';
import { Row } from 'react-bootstrap';
import ListingGridItem from 'components/common/listing/listing-item/ListingGridItem';

const GridView = () => {
  const { listings } = useSelector(state => state.home);
  return (
    <Row>
      {listings.map(listing => (
        <ListingGridItem
          listing={listing}
          key={listing.id}
          md={4}
          lg={3}
          myListingMode={false}
        />
      ))}
    </Row>
  );
};

export default GridView;
